import { useEffect, useState } from "react";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { trackPromise } from "react-promise-tracker";
import { useDispatch } from "react-redux";
import { resetPassword } from "../redux/actions/authAction";
import { GLOBALTYPES } from "../redux/actions/globalTypes";
import { getDataAPI } from "../utils/fetchData";

export default function Resetpassword() {
	const dispatch = useDispatch();

	const initialState = {
		password: "",
		cf_password: "",
	};
	const [userData, setUserData] = useState(initialState);
	const [errors, setErrors] = useState({});
	const [user, setUser] = useState({});
	const lengthOftext = 200;

	const [showPassword, setShowPassword] = useState(false);
	const [showConfirmPassword, setShowConfirmPassword] = useState(false);

	useEffect(() => {
		dispatch({ type: GLOBALTYPES.ALERT, payload: { loading: true } });

		trackPromise(
			getDataAPI(
				`checkToken/${window.location.pathname.split("/")[2]}`,
				window.location.pathname.split("/")[2]
			)
				.then((res) => {
					console.log("res getcoursecategory", res.data);

					if (res.status === 200) {
						setUser(res.data.user);
						dispatch({ type: GLOBALTYPES.ALERT, payload: { loading: false } });
					} else {
						alert("Link expired!!!");
					}
				})
				.catch((err) => {
					alert("Link expired");
					console.log(err);
					window.close();
				})
		);
	}, []);

	const handleChangeInput = (e) => {
		const { name, value } = e.target;
		setUserData({ ...userData, [name]: value });
	};

	const handleSubmit = (e) => {
		if (!validateForm()) return;
		e.preventDefault();
		console.log("userData", userData);
		dispatch(
			resetPassword({
				password: userData.password,
				token: window.location.pathname.split("/")[2],
				user: user,
			})
		);
	};

	const validateForm = () => {
		const newErrors = {};

		if (!userData.password) {
			newErrors.password = "Password is required.";
		} else if (
			!/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[\W_]).{8,}$/.test(
				userData.password
			)
		) {
			newErrors.passwordInvalid =
				"Password should contain at least one uppercase, lowercase, number, special character, and be at least 8 characters long.";
			console.log("enter");
		}

		if (!userData.cf_password) {
			newErrors.cf_password = "Confirm password is required.";
		}

		if (userData.password !== userData.cf_password) {
			newErrors.passwordDontMatch = "Password does not match.";
		}

		setErrors(newErrors);
		// console.log("newErrors", newErrors);
		return Object.keys(newErrors).length === 0;
	};

	return (
		<>
			{/* <Navbar /> */}
			<div id="testlogin" style={{ backgroundColor: "white" }}>
				<div className="spacer"></div>
				<div className="row">
					<div className="col-1"></div>
					<div className="col-10 block">
						<h5>Reset password</h5>
						<form>
							<div className="row">
								<div
									style={{
										display: "flex",
										justifyContent: "space-between",
									}}>
									<label className="email-label-2">
										Password{" "}
										<span style={{ color: "rgb(114, 28, 36)" }}>*</span>
									</label>
									<span
										className="toggle-password d-flex align-items-center"
										onClick={() => setShowPassword(!showPassword)}>
										{showPassword ? (
											<div style={{ cursor: "pointer" }}>
												<FaEyeSlash className="me-1" />
												Hide Password
											</div>
										) : (
											<div style={{ cursor: "pointer" }}>
												<FaEye className="me-1" />
												Show Password
											</div>
										)}
									</span>
								</div>
								<div className="password-input">
									<input
										className="password-input"
										type={showPassword ? "text" : "password"}
										value={userData.password}
										maxLength={lengthOftext}
										name="password"
										autoComplete="off"
										onChange={handleChangeInput}
										required
									/>
								</div>
								<p
									className="error-message ms-3"
									style={{
										visibility:
											errors.password || errors.passwordInvalid
												? "visible"
												: "hidden",
									}}>
									{errors.password ? errors.password : errors.passwordInvalid}
									{!errors.password && !errors.passwordInvalid && "Text"}
								</p>

								<div
									style={{
										display: "flex",
										justifyContent: "space-between",
									}}>
									<label className="email-label-2">
										Confirm Password{" "}
										<span style={{ color: "rgb(114, 28, 36)" }}>*</span>
									</label>
									<span
										className="toggle-password d-flex align-items-center"
										onClick={() =>
											setShowConfirmPassword(!showConfirmPassword)
										}>
										{showConfirmPassword ? (
											<div style={{ cursor: "pointer" }}>
												<FaEyeSlash className="me-1" />
												Hide Password
											</div>
										) : (
											<div style={{ cursor: "pointer" }}>
												<FaEye className="me-1" />
												Show Password
											</div>
										)}
									</span>
								</div>
								<div className="email-input">
									<input
										className="password-input"
										type={showConfirmPassword ? "text" : "password"}
										maxLength={lengthOftext}
										value={userData.cf_password}
										autoComplete="off"
										name="cf_password"
										onChange={handleChangeInput}
										required
									/>
								</div>
								<p
									className="error-message ms-3"
									style={{
										visibility:
											errors.cf_password || errors.passwordDontMatch
												? "visible"
												: "hidden",
									}}>
									{errors.cf_password
										? errors.cf_password
										: errors.passwordDontMatch}
									{!errors.cf_password && !errors.passwordDontMatch && "Text"}
								</p>
							</div>

							<button
								className="GetNewpassword"
								onClick={handleSubmit}
								type="button">
								Submit
							</button>
						</form>
					</div>

					<div className="col-1"></div>
				</div>

				<div className="spacer"></div>
			</div>
			{/* <Footer /> */}
		</>
	);
}
